var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgKeys = function SvgKeys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.714 21.5l-1.5 1.5-4.523-4.53 1.5-1.5-9.369-9.379a2.925 2.925 0 01-.779 1.472 2.781 2.781 0 01-3.92 0 2.791 2.791 0 010-3.925l.087-.087a2.179 2.179 0 01-.4-.318A2.747 2.747 0 011 2.771 2.758 2.758 0 013.768 0a2.745 2.745 0 011.96.808 3.2 3.2 0 01.258.318 1.371 1.371 0 01.259-.318 2.774 2.774 0 013.92 3.925 2.777 2.777 0 01-1.844.808L24 21.241 22.212 23z",
    fill: "#eca947"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M3.45 22.439L1.89 24 0 22.108l16.379-16.34a2.9 2.9 0 01-1.92-.842A2.884 2.884 0 0116.5 0a2.854 2.854 0 012.04.842 3.483 3.483 0 01.27.33 1.413 1.413 0 01.269-.33A2.881 2.881 0 0124 2.884a2.864 2.864 0 01-.841 2.043 4.086 4.086 0 01-.419.331.174.174 0 01.059.151 2.887 2.887 0 01-4.081 4.085 2.744 2.744 0 01-.809-1.533l-9.75 9.762 1.56 1.562L5.009 24z",
    fill: "#eca947"
  })));
};

export default SvgKeys;